const getters = {
    // 上传图片中通用图片地址
    website:state => state.website.website
}

export default getters